{
  "sv": {
    "H200": "Instabilt, explosivt.",
    "H201": "Explosivt. Fara för massexplosion.",
    "H202": "Explosivt. Allvarlig fara för splitter och kaststycken.",
    "H203": "Explosivt. Fara för brand, tryckvåg eller splitter och kaststycken.",
    "H204": "Fara för brand eller splitter och kaststycken.",
    "H205": "Fara för massexplosion vid brand.",
    "H206": "Fara för brand, tryckvåg eller splitter och kaststycken, ökad explosionsrisk om det okänsliggörande ämnet minskas.",
    "H207": "Fara för brand eller splitter och kaststycken, ökad explosionsrisk om det okänsliggörande ämnet minskas.",
    "H208": "Fara för brand, ökad explosionsrisk om det okänsliggörande ämnet minskas.",
    "H209": "Explosivt.",
    "H210": "Mycket känsligt.",
    "H211": "Kan vara känsligt.",
    "H220": "Extremt brandfarlig gas.",
    "H221": "Brandfarlig gas.",
    "H222": "Extremt brandfarlig aerosol.",
    "H223": "Brandfarlig aerosol.",
    "H224": "Extremt brandfarlig vätska och ånga.",
    "H225": "Mycket brandfarlig vätska och ånga.",
    "H226": "Brandfarlig vätska och ånga.",
    "H227": "Brännbar vätska.",
    "H228": "Brandfarligt fast ämne.",
    "H229": "Tryckbehållare: Kan sprängas vid uppvärmning.",
    "H230": "Kan reagera explosivt även i frånvaro av luft.",
    "H231": "Kan reagera explosivt även i frånvaro av luft vid förhöjt tryck och/eller temperatur.",
    "H232": "Kan spontanantända vid kontakt med luft.",
    "H240": "Explosivt vid uppvärmning.",
    "H241": "Brandfarligt eller explosivt vid uppvärmning.",
    "H242": "Brandfarligt vid uppvärmning.",
    "H250": "Spontanantänder vid kontakt med luft.",
    "H251": "Självupphettande. Kan börja brinna.",
    "H252": "Självupphettande i stora mängder. Kan börja brinna.",
    "H260": "Vid kontakt med vatten utvecklas brandfarliga gaser som kan självantända.",
    "H261": "Vid kontakt med vatten utvecklas brandfarliga gaser.",
    "H270": "Kan orsaka eller intensifiera brand. Oxiderande.",
    "H271": "Kan orsaka brand eller explosion. Starkt oxiderande.",
    "H272": "Kan intensifiera brand. Oxiderande.",
    "H280": "Innehåller gas under tryck. Kan explodera vid uppvärmning.",
    "H281": "Innehåller kyld gas. Kan orsaka svåra köldskador.",
    "H282": "Extremt brandfarlig, kemiskt instabil gas.",
    "H283": "Brandfarlig, kemiskt instabil gas.",
    "H284": "Kemiskt instabil gas.",
    "H290": "Kan vara korrosivt för metaller.",
    "H300": "Dödligt vid förtäring.",
    "H301": "Giftigt vid förtäring.",
    "H302": "Skadligt vid förtäring.",
    "H303": "Kan vara skadligt vid förtäring.",
    "H304": "Kan vara dödligt vid förtäring om det kommer ner i luftvägarna.",
    "H305": "Kan vara skadligt vid förtäring om det kommer ner i luftvägarna.",
    "H310": "Dödligt vid hudkontakt.",
    "H311": "Giftigt vid hudkontakt.",
    "H312": "Skadligt vid hudkontakt.",
    "H313": "Kan vara skadligt vid hudkontakt.",
    "H314": "Orsakar allvarliga frätskador på hud och ögon.",
    "H315": "Irriterar huden.",
    "H316": "Orsakar mild hudirritation.",
    "H317": "Kan orsaka allergisk hudreaktion.",
    "H318": "Orsakar allvarliga ögonskador.",
    "H319": "Orsakar allvarlig ögonirritation.",
    "H320": "Orsakar ögonirritation.",
    "H330": "Dödligt vid inandning.",
    "H331": "Giftigt vid inandning.",
    "H332": "Skadligt vid inandning.",
    "H333": "Kan vara skadligt vid inandning.",
    "H334": "Kan orsaka allergi- eller astmasymtom eller andningssvårigheter vid inandning.",
    "H335": "Kan orsaka irritation i luftvägarna.",
    "H336": "Kan göra att man blir dåsig eller omtöcknad.",
    "H340": "Kan orsaka genetiska defekter <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H341": "Misstänks kunna orsaka genetiska defekter <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H350": "Kan orsaka cancer <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H350i": "Kan orsaka cancer vid inandning.",
    "H351": "Misstänks kunna orsaka cancer <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H360": "Kan skada fertiliteten eller det ofödda barnet <ange specifik effekt om denna är känd> <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H360F": "Kan skada fertiliteten.",
    "H360D": "Kan skada det ofödda barnet.",
    "H360FD": "Kan skada fertiliteten. Kan skada det ofödda barnet.",
    "H360Fd": "Kan skada fertiliteten. Misstänks kunna skada det ofödda barnet.",
    "H360Df": "Kan skada det ofödda barnet. Misstänks kunna skada fertiliteten.",
    "H361": "Misstänks kunna skada fertiliteten eller det ofödda barnet <ange specifik effekt om denna är känd> <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H361f": "Misstänks kunna skada fertiliteten.",
    "H361d": "Misstänks kunna skada det ofödda barnet.",
    "H361fd": "Misstänks kunna skada fertiliteten. Misstänks kunna skada det ofödda barnet.",
    "H362": "Kan skada spädbarn som ammas.",
    "H370": "Orsakar organskador <eller ange vilka organ som påverkas, om detta är känt> <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H371": "Kan orsaka organskador <eller ange vilka organ som påverkas, om detta är känt> <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H372": "Orsakar organskador <eller ange vilka organ som påverkas, om detta är känt> genom lång eller upprepad exponering <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H373": "Kan orsaka organskador <eller ange vilka organ som påverkas, om detta är känt> genom lång eller upprepad exponering <ange exponeringsväg om det är definitivt bevisat att faran inte kan orsakas av några andra exponeringsvägar>.",
    "H400": "Mycket giftigt för vattenlevande organismer.",
    "H410": "Mycket giftigt för vattenlevande organismer med långtidseffekter.",
    "H411": "Giftigt för vattenlevande organismer med långtidseffekter.",
    "H412": "Skadliga långtidseffekter för vattenlevande organismer.",
    "H413": "Kan ge skadliga långtidseffekter på vattenlevande organismer.",
    "H420": "Skadar folkhälsan och miljön genom att förstöra ozonet i övre delen av atmosfären.",
    "H300+H310": "Dödligt vid förtäring eller vid hudkontakt.",
    "H300+H330": "Dödligt vid förtäring eller inandning.",
    "H310+H330": "Dödligt vid hudkontakt eller inandning.",
    "H300+H310+H330": "Dödligt vid förtäring, hudkontakt eller inandning.",
    "H301+H311": "Giftigt vid förtäring eller hudkontakt.",
    "H301+H331": "Giftigt vid förtäring eller inandning.",
    "H311+H331": "Giftigt vid hudkontakt eller inandning.",
    "H301+H311+H331": "Giftigt vid förtäring, hudkontakt eller inandning.",
    "H302+H312": "Skadligt vid förtäring eller hudkontakt.",
    "H302+H332": "Skadligt vid förtäring eller inandning.",
    "H312+H332": "Skadligt vid hudkontakt eller inandning.",
    "H302+H312+H332": "Skadligt vid förtäring, hudkontakt eller inandning."
  },
  "pl": {
    "H200": "Niestabilny materiał wybuchowy.",
    "H201": "Materiał wybuchowy; zagrożenie wybuchem masowym.",
    "H202": "Materiał wybuchowy; poważne zagrożenie rozrzutem.",
    "H203": "Materiał wybuchowy; zagrożenie pożarem, wybuchem lub rozrzutem.",
    "H204": "Zagrożenie pożarem lub rozrzutem.",
    "H205": "Może wybuchać masowo w przypadku pożaru.",
    "H206": "Zagrożenie pożarem, wybuchem lub rozrzutem; zwiększone ryzyko wybuchu, jeśli zawartość środka odczulającego została zmniejszona.",
    "H207": "Zagrożenie pożarem lub rozrzutem; zwiększone ryzyko wybuchu, jeśli zawartość środka odczulającego została zmniejszona.",
    "H208": "Zagrożenie pożarem; zwiększone ryzyko wybuchu, jeśli zawartość środka odczulającego została zmniejszona.",
    "H209": "Materiał wybuchowy.",
    "H210": "Bardzo wrażliwy.",
    "H211": "Może być wrażliwy.",
    "H220": "Skrajnie łatwopalny gaz.",
    "H221": "Łatwopalny gaz.",
    "H222": "Skrajnie łatwopalny aerozol.",
    "H223": "Łatwopalny aerozol.",
    "H224": "Skrajnie łatwopalna ciecz i pary.",
    "H225": "Wysoce łatwopalna ciecz i pary.",
    "H226": "Łatwopalna ciecz i pary.",
    "H227": "Ciecz palna.",
    "H228": "Substancja stała łatwopalna.",
    "H229": "Pojemnik pod ciśnieniem: Ogrzanie grozi wybuchem.",
    "H230": "Może reagować wybuchowo nawet bez dostępu powietrza.",
    "H231": "Może reagować wybuchowo nawet bez dostępu powietrza przy podwyższonym ciśnieniu i/lub podwyższonej temperaturze.",
    "H232": "Może ulegać samozapaleniu w przypadku wystawienia na działanie powietrza.",
    "H240": "Ogrzanie grozi wybuchem.",
    "H241": "Ogrzanie może spowodować pożar lub wybuch.",
    "H242": "Ogrzanie może spowodować pożar.",
    "H250": "Zapala się samorzutnie w przypadku wystawienia na działanie powietrza.",
    "H251": "Substancja samonagrzewająca się; może się zapalić.",
    "H252": "Substancja samonagrzewająca się w dużych ilościach; może się zapalić.",
    "H260": "W kontakcie z wodą uwalnia łatwopalne gazy, które mogą ulegać samozapaleniu.",
    "H261": "W kontakcie z wodą uwalnia łatwopalne gazy.",
    "H270": "Może spowodować lub intensyfikować pożar; utleniacz.",
    "H271": "Może spowodować pożar lub wybuch; silny utleniacz.",
    "H272": "Może intensyfikować pożar; utleniacz.",
    "H280": "Zawiera gaz pod ciśnieniem; ogrzanie grozi wybuchem.",
    "H281": "Zawiera schłodzony gaz; może spowodować oparzenia kriogeniczne lub obrażenia.",
    "H282": "Skrajnie łatwopalny, chemicznie niestabilny gaz.",
    "H283": "Łatwopalny, chemicznie niestabilny gaz.",
    "H284": "Chemicznie niestabilny gaz.",
    "H290": "Może powodować korozję metali.",
    "H300": "Połknięcie grozi śmiercią.",
    "H301": "Działa toksycznie po połknięciu.",
    "H302": "Działa szkodliwie po połknięciu.",
    "H303": "Może działać szkodliwie po połknięciu.",
    "H304": "Połknięcie i dostanie się przez drogi oddechowe może grozić śmiercią.",
    "H305": "Może działać szkodliwie po połknięciu i dostaniu się do dróg oddechowych.",
    "H310": "Grozi śmiercią w kontakcie ze skórą.",
    "H311": "Działa toksycznie w kontakcie ze skórą.",
    "H312": "Działa szkodliwie w kontakcie ze skórą.",
    "H313": "Może działać szkodliwie w kontakcie ze skórą.",
    "H314": "Powoduje poważne oparzenia skóry oraz uszkodzenia oczu.",
    "H315": "Działa drażniąco na skórę.",
    "H316": "Powoduje łagodne podrażnienie skóry.",
    "H317": "Może powodować reakcję alergiczną skóry.",
    "H318": "Powoduje poważne uszkodzenie oczu.",
    "H319": "Działa drażniąco na oczy.",
    "H320": "Powoduje podrażnienie oczu.",
    "H330": "Wdychanie grozi śmiercią.",
    "H331": "Działa toksycznie w następstwie wdychania.",
    "H332": "Działa szkodliwie w następstwie wdychania.",
    "H333": "Może działać szkodliwie w następstwie wdychania.",
    "H334": "Może powodować objawy alergii lub astmy lub trudności w oddychaniu w następstwie wdychania.",
    "H335": "Może powodować podrażnienie dróg oddechowych.",
    "H336": "Może wywoływać uczucie senności lub zawroty głowy.",
    "H340": "Może powodować wady genetyczne <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H341": "Podejrzewa się, że powoduje wady genetyczne <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H350": "Może powodować raka <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H350i": "Wdychanie może spowodować raka.",
    "H351": "Podejrzewa się, że powoduje raka <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H360": "Może działać szkodliwie na płodność lub na dziecko w łonie matki <podać szczególny skutek, jeżeli jest znany> <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H360F": "Może działać szkodliwie na płodność.",
    "H360D": "Może działać szkodliwie na dziecko w łonie matki.",
    "H360FD": "Może działać szkodliwie na płodność. Może działać szkodliwie na dziecko w łonie matki.",
    "H360Fd": "Może działać szkodliwie na płodność. Podejrzewa się, że działa szkodliwie na dziecko w łonie matki.",
    "H360Df": "Może działać szkodliwie na dziecko w łonie matki. Podejrzewa się, że działa szkodliwie na płodność.",
    "H361": "Podejrzewa się, że działa szkodliwie na płodność lub na dziecko w łonie matki <podać szczególny skutek, jeżeli jest znany> <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H361f": "Podejrzewa się, że działa szkodliwie na płodność.",
    "H361d": "Podejrzewa się, że działa szkodliwie na dziecko w łonie matki.",
    "H361fd": "Podejrzewa się, że działa szkodliwie na płodność. Podejrzewa się, że działa szkodliwie na dziecko w łonie matki.",
    "H362": "Może działać szkodliwie na dzieci karmione piersią.",
    "H370": "Powoduje uszkodzenie narządów <podać wszystkie znane narządy, których to dotyczy> <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H371": "Może powodować uszkodzenie narządów <podać wszystkie znane narządy, których to dotyczy> <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H372": "Powoduje uszkodzenie narządów <podać wszystkie znane narządy, których to dotyczy> poprzez długotrwałe lub powtarzane narażenie <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H373": "Może powodować uszkodzenie narządów <podać wszystkie znane narządy, których to dotyczy> poprzez długotrwałe lub powtarzane narażenie <podać drogę narażenia, jeżeli definitywnie udowodniono, że inne drogi narażenia nie stwarzają zagrożenia>.",
    "H400": "Działa bardzo toksycznie na organizmy wodne.",
    "H410": "Działa bardzo toksycznie na organizmy wodne, powodując długotrwałe skutki.",
    "H411": "Działa toksycznie na organizmy wodne, powodując długotrwałe skutki.",
    "H412": "Działa szkodliwie na organizmy wodne, powodując długotrwałe skutki.",
    "H413": "Może powodować długotrwałe szkodliwe skutki dla organizmów wodnych.",
    "H420": "Stwarza zagrożenie dla zdrowia publicznego i środowiska poprzez niszczące oddziaływanie na ozon w górnej warstwie atmosfery.",
    "H300+H310": "Grozi śmiercią po połknięciu lub w kontakcie ze skórą.",
    "H300+H330": "Grozi śmiercią po połknięciu lub w następstwie wdychania.",
    "H310+H330": "Grozi śmiercią w kontakcie ze skórą lub w następstwie wdychania.",
    "H300+H310+H330": "Grozi śmiercią po połknięciu, w kontakcie ze skórą lub w następstwie wdychania.",
    "H301+H311": "Działa toksycznie po połknięciu lub w kontakcie ze skórą.",
    "H301+H331": "Działa toksycznie po połknięciu lub w następstwie wdychania.",
    "H311+H331": "Działa toksycznie w kontakcie ze skórą lub w następstwie wdychania.",
    "H301+H311+H331": "Działa toksycznie po połknięciu, w kontakcie ze skórą lub w następstwie wdychania.",
    "H302+H312": "Działa szkodliwie po połknięciu lub w kontakcie ze skórą.",
    "H302+H332": "Działa szkodliwie po połknięciu lub w następstwie wdychania.",
    "H312+H332": "Działa szkodliwie w kontakcie ze skórą lub w następstwie wdychania.",
    "H302+H312+H332": "Działa szkodliwie po połknięciu, w kontakcie ze skórą lub w następstwie wdychania."
  }
}
